import {SummaryModel} from "../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";


export class AgendaCalendarSummaryModel implements SummaryModel{
    id: number;
    permissions: PermissionsModel;
    name: string;
    color: string;
    textColor: string;
}
